export default __webpack_public_path__ + "static/test_1_3-2a140a817462b758a0bc626075a6cc51.png";